module.exports = __webpack_public_path__ + "img/mayhem.6a50278f.png";